// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__2gItB","path":"style_path__2rbwb","arrow":"style_arrow__1BojJ"};